import { Btn, Breadcrumbs } from '../../AbstractElements';
import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './SosData';
import axios from 'axios';
import { ServerPath } from '../../Constant';
import Swal from 'sweetalert2';
import { Button, Form } from 'react-bootstrap';
import { _axios } from '../../utils/axios';
import UpdatePurple from '../../assets/images/svg/UpdatePurple.svg';
import UpdateBlue from '../../assets/images/svg/UpdateBlue.svg';
import EditSos from './EditSos';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { formatToIndianTimeShort } from '../../utils/timeUtils';

const SosTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Pending', value: 'pending' },
        { label: 'Dispatched', value: 'dispatched' },
        { label: 'Closed & Delegated', value: 'closed & delegated' },
        { label: 'Closed', value: 'closed' },
        { label: 'Cancelled', value: 'cancelled' }
    ];
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    // Add this handler for page changes
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Add this handler for rows per page changes
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };


    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        console.log('Date Range Selected:', item.selection);
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };
    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };
    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                const formattedSosId = `SOS-${item.sos_id.toString().padStart(3, '0')}`.toLowerCase();
                const numericSearch = searchTerm.replace(/\D/g, '');
                const sosIdMatch = numericSearch ?
                    item.sos_id.toString() === numericSearch ||
                    formattedSosId.includes(searchTerm)
                    : formattedSosId.includes(searchTerm);
                return (
                    sosIdMatch ||
                    String(item.original_emergency_type || '').toLowerCase().includes(searchTerm) ||
                    String(item.original_user_name || '').toLowerCase().includes(searchTerm) ||
                    String(item.original_status || '').toLowerCase().includes(searchTerm) ||
                    String(item.original_mobile || '').toLowerCase().includes(searchTerm) ||
                    String(item.original_bloodgroup || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply status filter
        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item =>
                item.original_status?.toLowerCase() === filterValue.toLowerCase()
            );
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                // Convert the item's created_at string back to a Date object for comparison
                // Remove the time formatting to get the original date string
                const itemDateStr = item.created_at.split(' ')[0]; // Extract date part only
                const itemDate = new Date(itemDateStr);

                // Set time to start of day for consistent comparison
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);

                // Set time to end of day for consistent comparison
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);

                console.log('Date comparison:', {
                    itemDate: itemDate.toISOString(),
                    startDate: startDate.toISOString(),
                    endDate: endDate.toISOString(),
                    isInRange: itemDate >= startDate && itemDate <= endDate
                });

                return itemDate >= startDate && itemDate <= endDate;
            });
        }

        setData(filteredData);
    };

    // const handleSearch = (value) => {
    //     setSearchValue(value);
    //     applyFiltersAndSearch(value, selectedFilter, selectedDate);
    // };

    const handleSearch = (value) => {
        setSearchValue(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        // Parse date string in format "MM/DD/YYYY, HH:MM AM/PM"
        const [datePart, timePart] = dateStr.split(', ');
        const [month, day, year] = datePart.split('/');
        return new Date(year, month - 1, day); // month is 0-based in JavaScript
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${ServerPath}/sos/admin`);
                const actualData = response?.data.data;

                const sosData = actualData.map(sos => {
                    const transformedData = {
                        ...sos,
                        sos_id: sos.sos_id,
                        // Store original values for searching
                        original_emergency_type: sos.emergency_type,
                        original_user_name: sos.user_name,
                        original_status: sos.status?.toLowerCase(),
                        original_mobile: sos.mobile,
                        original_bloodgroup: sos.bloodgroup,
                        original_created_at: parseDate(sos.created_at), // Parse the date here
                        created_at: sos.created_at, // Keep the formatted date for display
                        // Display transformed data
                        user_name: <div className="align-self-center">
                            <div>{sos?.emergency_type || 'N/A'}</div>
                        </div>,
                        mobile: <div className="align-self-center">
                            <div>{sos?.user_name || 'N/A'}</div>
                        </div>,
                        emergency_type: (
                            <span>
                                {sos?.status || 'N/A'}
                            </span>
                        ),
                        bloodgroup: <div className="align-self-center">
                            <div>{sos?.mobile || 'N/A'}</div>
                        </div>,
                        age: <div className="align-self-center">
                            <div>{sos?.bloodgroup || 'N/A'}</div>
                        </div>,
                        action: (
                            <div className="action d-flex justify-content-center">
                                <EditSos data={sos} />
                            </div>
                        ),
                    };
                    console.log('Original Status:', sos.status, 'Transformed Status:', sos.status?.toLowerCase());
                    return transformedData;
                });

                setOriginalData(sosData);
                setData(sosData);

            } catch (error) {
                console.error('Error in fetchData:', error);
                Swal.fire('Error!', 'Failed to fetch SOS data', 'error');
            }
        };

        fetchData();
    }, []);

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleMultiDelete = () => {
        if (window.confirm(`Are you sure you want to delete the selected items?`)) {
            setToggleDelete(!toggleDelete);
            const updatedData = data.filter((item) => !selectedRows.find(row => row.sos_id === item.sos_id));
            setData(updatedData);
            setOriginalData(updatedData);
            setSelectedRows([]);
        }
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <div className='row align-items-center mb-1'>
                    <div className='col-9'>
                        <Breadcrumbs mainTitle="Recent Request Logs" parent="Dashboard" title="SOS Records" />
                    </div>
                    <div className='col-3'>
                        <div className="d-flex justify-content-end gap-1">
                            {/* Search Component */}
                            <div className="position-relative" ref={searchRef}>
                                <button
                                    className="bg-transparent border-0"
                                    onClick={() => setShowSearch(true)}
                                >
                                    <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                                </button>

                                {showSearch && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '45px',
                                            left: '-180px',
                                            width: '220px',
                                            zIndex: 1000
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: 'white',
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                padding: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}
                                        >
                                            <div
                                                style={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    background: '#F8F7FA',
                                                    borderRadius: '6px',
                                                    padding: '6px 12px'
                                                }}
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Search Here..."
                                                    value={searchValue}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        border: 'none',
                                                        background: 'transparent',
                                                        fontSize: '14px',
                                                        color: '#666',
                                                        outline: 'none'
                                                    }}
                                                    autoFocus
                                                />
                                                <button
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        padding: 0,
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                    onClick={() => handleSearch(searchValue)}
                                                >
                                                    <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Calendar Component */}
                            <div className="position-relative" ref={calendarRef}>
                                <button
                                    className="bg-transparent border-0"
                                    onClick={() => setShowCalendar(!showCalendar)}
                                >
                                    <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                                </button>

                                {showCalendar && (
                                    <div
                                        className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                        style={{
                                            width: 'auto',
                                            maxWidth: '300px',
                                            zIndex: 1000,
                                            right: 0
                                        }}
                                    >
                                        <style>
                                            {`
                                            .date-range {
                                                font-size: 12px !important;
                                            }
                                            .date-range .rdrMonth {
                                                width: 240px !important;
                                                padding: 0 !important;
                                            }
                                            .date-range .rdrCalendarWrapper {
                                                font-size: 12px !important;
                                                width: 240px !important;
                                                border-radius: 8px !important;
                                                overflow: hidden !important;  /* This will ensure content doesn't overflow */
                                                background: white !important;
                                            }
                                            .date-range .rdrDateDisplayWrapper {
                                                display: none !important;
                                            }
                                            .rdrMonthAndYearWrapper {
                                                padding-top: 5px !important;
                                                height: 40px !important;
                                            }
                                            .rdrMonth {
                                                padding: 0 !important;
                                            }
                                        `}
                                        </style>
                                        <DateRange
                                            editableDateInputs={true}
                                            onChange={handleDateRangeChange}
                                            moveRangeOnFirstSelection={false}
                                            ranges={dateRange}
                                            maxDate={new Date()}
                                            months={1}
                                            direction="horizontal"
                                            className="date-range"
                                            staticRanges={[]}
                                            inputRanges={[]}
                                            rangeColors={['#0066ff']}
                                            minDate={new Date("2000-01-01")}
                                            showSelectionPreview={true}
                                            showMonthAndYearPickers={true}
                                            monthDisplayFormat="MMMM yyyy"
                                            dayDisplayFormat="d"
                                            showDateDisplay={false}
                                            monthsShown={1}
                                        />
                                        <div className="d-flex justify-content-end mt-2">
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={clearDateFilter}
                                            >
                                                Clear
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Filter Component */}
                            <div className="position-relative" ref={dropdownRef}>
                                <button
                                    className="bg-transparent border-0"
                                    onClick={() => setShowDropdown(!showDropdown)}
                                >
                                    <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                                </button>

                                {showDropdown && (
                                    <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2" style={{ width: '200px', zIndex: 1000 }}>
                                        <style>
                                            {`
                                                .form-check-label {
                                                    font-weight: 400 !important;
                                                }
                                                .form-check-input[type=checkbox] {
                                                    border-radius: 0 !important;
                                                }
                                            `}
                                        </style>
                                        <Form>
                                            {filterOptions.map((option) => (
                                                <Form.Check
                                                    key={option.value}
                                                    type="checkbox"
                                                    name="filterOption"
                                                    id={`filter-${option.value}`}
                                                    label={option.label}
                                                    checked={selectedFilter === option.value}
                                                    onChange={() => handleFilterChange(option.value)}
                                                />
                                            ))}
                                        </Form>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className='pt-0'>
                                {selectedRows.length > 0 && (
                                    <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                                        <h4 className="text-muted m-0">Delete Selected Records?</h4>
                                        <Btn attrBtn={{ color: 'danger', onClick: handleMultiDelete }}>Delete</Btn>
                                    </div>
                                )}
                                <DataTable
                                    className='data-tables theme-scrollbar pt-4'
                                    data={data}
                                    // columns={tableColumns}
                                    columns={tableColumns.map(col => ({
                                        ...col,
                                        selector: typeof col.selector === 'function'
                                            ? (row, index) => col.selector(row, index, currentPage, perPage)
                                            : col.selector
                                    }))}
                                    striped={true}
                                    center={true}
                                    // pagination
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={data.length}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    selectableRows
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default SosTable;